// import emailjs from '@emailjs/browser';

// emailjs.init('gG8XGHDepX1bUiphF');

// const form = document.getElementById('contact-form');
// const errorMsg = document.getElementById('form-error');
// const submitBtn = form.querySelector('button[type="submit"]');

// form.addEventListener('submit', e => {
//   e.preventDefault();

//   if (!form.checkValidity()) {
//     form.reportValidity();
//     errorMsg.hidden = false;
//     return;
//   }

//   errorMsg.hidden = true;
//   submitBtn.disabled = true;
//   submitBtn.textContent = 'Надсилаємо...';

//   emailjs
//     .sendForm('service_2482erg', 'template_viskrid', form)
//     .then(() => {
//       form.reset();
//       showThanks();
//     })
//     .catch(err => {
//       console.error('EmailJS error:', err);
//       errorMsg.textContent = 'Сталася помилка. Спробуйте ще раз.';
//       errorMsg.hidden = false;
//     })
//     .finally(() => {
//       submitBtn.disabled = false;
//       submitBtn.textContent = 'НАДІСЛАТИ';
//     });
// });

// function showThanks() {
//   const thanksScreen = document.getElementById('thanks');
//   thanksScreen.hidden = false;
//   document.body.classList.add('thanks-active');
//   document.body.style.overflow = 'hidden';
// }

// function hideThanks() {
//   const thanksScreen = document.getElementById('thanks');
//   if (!thanksScreen) return;
//   thanksScreen.hidden = true;
//   document.body.classList.remove('thanks-active');
//   document.body.style.overflow = '';
// }

// function initThanksLogoClose() {
//   const thanksScreen = document.getElementById('thanks');
//   if (!thanksScreen) return;

//   const logoLink = thanksScreen.querySelector('.logo-footer a');
//   if (!logoLink) return;

//   logoLink.addEventListener('click', e => {
//     e.preventDefault();
//     hideThanks();
//     document.getElementById('hero')?.scrollIntoView({ behavior: 'smooth' });
//   });
// }

// window.addEventListener('load', initThanksLogoClose);

import emailjs from '@emailjs/browser';

emailjs.init('gG8XGHDepX1bUiphF');

const form = document.getElementById('contact-form');
const errorMsg = document.getElementById('form-error');
const submitBtn = form.querySelector('button[type="submit"]');

async function sendToN8N() {
  const data = {
    name: form.user_name.value,
    email: form.user_email.value,
    phone: form.user_phone.value,
    page: window.location.href,
    created_at: new Date().toISOString(),
  };

  const response = await fetch(
    'https://n8n.analytics.shelest.ua/webhook/1aa03a52-b3b9-4822-9e43-e9c015541f6c',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error('Failed to send data to n8n');
  }
}

form.addEventListener('submit', e => {
  e.preventDefault();

  if (!form.checkValidity()) {
    form.reportValidity();
    errorMsg.hidden = false;
    return;
  }

  errorMsg.hidden = true;
  submitBtn.disabled = true;
  submitBtn.textContent = 'Надсилаємо...';

  emailjs
    .sendForm('service_2482erg', 'template_viskrid', form)
    .then(async () => {
      try {
        await sendToN8N();
      } catch (err) {
        console.error('n8n webhook error:', err);
      }

      form.reset();
      showThanks();
    })
    .catch(err => {
      console.error('EmailJS error:', err);
      errorMsg.textContent = 'Сталася помилка. Спробуйте ще раз.';
      errorMsg.hidden = false;
    })
    .finally(() => {
      submitBtn.disabled = false;
      submitBtn.textContent = 'НАДІСЛАТИ';
    });
});

function showThanks() {
  const thanksScreen = document.getElementById('thanks');
  thanksScreen.hidden = false;
  document.body.classList.add('thanks-active');
  document.body.style.overflow = 'hidden';
}

function hideThanks() {
  const thanksScreen = document.getElementById('thanks');
  if (!thanksScreen) return;

  thanksScreen.hidden = true;
  document.body.classList.remove('thanks-active');
  document.body.style.overflow = '';
}

function initThanksLogoClose() {
  const thanksScreen = document.getElementById('thanks');
  if (!thanksScreen) return;

  const logoLink = thanksScreen.querySelector('.logo-footer a');
  if (!logoLink) return;

  logoLink.addEventListener('click', e => {
    e.preventDefault();
    hideThanks();
    document.getElementById('hero')?.scrollIntoView({
      behavior: 'smooth',
    });
  });
}

window.addEventListener('load', initThanksLogoClose);
